import * as React from "react";
import { NameView, InfoViewGrid1, InfoViewGrid2, PriceView, OriginalPriceView, CollectViewOrange, InfoBottomStyle2, NameViewWithTag, InfoBottomLeftText, InfoViewGridBase, ShipTo24HoursBox, ActTagViewForMGrid, ScoreTextView, } from "./styles";
import { CommentStarForM } from "../../../components/CommentStar";
import { isValidNumber } from "../../../utils/number";
import { oneMoreWords } from "../../../utils/string";
export const ProductInfoGrid1 = (props) => {
    var _a;
    const { name, price, originalPrice, collect, actTags, collectOptions = {}, shipIn24hours, } = props;
    return (React.createElement(InfoViewGrid1, null,
        React.createElement("section", null,
            NameViewGrid(name, 1, { fixedCol: actTags ? 1 : undefined }),
            actTags && React.createElement(ActTagViewForM, { actTags: actTags }),
            PriceViews({
                price,
                columnNum: 1,
                originPrice: originalPrice,
            })),
        React.createElement(InfoBottomStyle2, { gridCol: 1 },
            isValidNumber(collect === null || collect === void 0 ? void 0 : collect.score) ? (React.createElement(React.Fragment, null,
                React.createElement(CommentStarForM, { rateScore: +((collect === null || collect === void 0 ? void 0 : collect.score) || 0), settingOption: collectOptions }, (collectOptions === null || collectOptions === void 0 ? void 0 : collectOptions.widthScore) ? (React.createElement(ScoreTextView, null, oneMoreWords((_a = collect === null || collect === void 0 ? void 0 : collect.score) === null || _a === void 0 ? void 0 : _a.toString()))) : null))) : (React.createElement(InfoBottomLeftText, null, collect === null || collect === void 0 ? void 0 : collect.score)),
            collect && CollectViews({ collect })),
        shipIn24hours && React.createElement(ShipTo24HoursView, { text: shipIn24hours })));
};
export const ProductInfoGrid2 = (props) => {
    const { name, price, originalPrice, titleIcon = "", actTags, shipIn24hours, displayInfo, } = props;
    return (React.createElement(InfoViewGrid2, null,
        !(displayInfo === null || displayInfo === void 0 ? void 0 : displayInfo.hideTitle) && (React.createElement(React.Fragment, null,
            NameViewGrid(name, 2, { titleIcon, fixedCol: actTags ? 1 : undefined }),
            actTags && (React.createElement(ActTagViewForM, { actTags: actTags, style: {
                    padding: "0 0.625rem",
                } })))),
        PriceViews({
            price,
            columnNum: 2,
            originPrice: originalPrice,
        }),
        RenderGrid2Collect(props),
        shipIn24hours && !(displayInfo === null || displayInfo === void 0 ? void 0 : displayInfo.hideShipIn24hours) && (React.createElement(ShipTo24HoursView, { text: shipIn24hours, style: { padding: "0 0.625rem" } }))));
};
function RenderGrid2Collect({ displayInfo, collect, collectOptions = {} }) {
    if (displayInfo === null || displayInfo === void 0 ? void 0 : displayInfo.hideCollection) {
        return null;
    }
    if ((!(collectOptions === null || collectOptions === void 0 ? void 0 : collectOptions.withStar) || !(collect === null || collect === void 0 ? void 0 : collect.score)) && !(collect === null || collect === void 0 ? void 0 : collect.text)) {
        return null;
    }
    return (React.createElement(InfoBottomStyle2, { gridCol: 2 },
        isValidNumber(collect === null || collect === void 0 ? void 0 : collect.score) ? (React.createElement(React.Fragment, null, RenderGrid2Star({ collect, collectOptions }))) : null,
        collect && CollectViews({ collect })));
}
function RenderGrid2Star({ collectOptions = {}, collect, }) {
    var _a;
    if (!(collectOptions === null || collectOptions === void 0 ? void 0 : collectOptions.withStar)) {
        return null;
    }
    return (React.createElement(CommentStarForM, { rateScore: +((collect === null || collect === void 0 ? void 0 : collect.score) || 0), settingOption: collectOptions }, (collectOptions === null || collectOptions === void 0 ? void 0 : collectOptions.widthScore) && (React.createElement(ScoreTextView, null, oneMoreWords((_a = collect === null || collect === void 0 ? void 0 : collect.score) === null || _a === void 0 ? void 0 : _a.toString())))));
}
export const ProductInfoGrid3 = (props) => {
    const { price } = props;
    return (React.createElement(InfoViewGridBase, null, PriceViews({
        price,
        columnNum: 3,
    })));
};
export const NameViewGrid = (name, columnNum, { titleIcon, fixedCol }) => {
    return (React.createElement(NameView, { gridCol: columnNum, fixedCol: fixedCol },
        titleIcon && React.createElement(NameViewWithTag, { src: titleIcon }),
        name));
};
const PriceViews = ({ price, columnNum, originPrice, className = "" }) => {
    return (React.createElement(PriceView, { gridCol: columnNum, className: className },
        React.createElement("span", { className: "price" }, price),
        originPrice && originPrice !== price && (React.createElement(OriginalPriceView, null, originPrice))));
};
const CollectViews = ({ collect }) => {
    return React.createElement(CollectViewOrange, null, collect === null || collect === void 0 ? void 0 : collect.text);
};
const ShipTo24HoursView = ({ text, style = {} }) => {
    return React.createElement(ShipTo24HoursBox, { style: style }, text);
};
const ActTagViewForM = ({ actTags = [], style = {}, }) => {
    return (React.createElement(ActTagViewForMGrid, { style: style }, (actTags || []).map((item, index) => (React.createElement("img", { key: `${item}${index}`, src: item, alt: "" })))));
};
